import { render, staticRenderFns } from "./CustomMetricsTagChart.vue?vue&type=template&id=6fe74f4e&scoped=true"
import script from "./CustomMetricsTagChart.vue?vue&type=script&lang=js"
export * from "./CustomMetricsTagChart.vue?vue&type=script&lang=js"
import style0 from "./CustomMetricsTagChart.vue?vue&type=style&index=0&id=6fe74f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe74f4e",
  null
  
)

export default component.exports